(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-hero-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-studio-hero')) {
    customElements.define('mp-studio-hero', class extends HTMLElement {
      connectedCallback() {
        this.life = new AbortController();
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
        this.compact = matchMedia('(max-width: 989px)');
        this.reduce.addEventListener('change', () => { this.clear(); this.prepare(); }, {signal:this.life.signal});
        this.compact.addEventListener('change', () => { this.clear(); this.prepare(); }, {signal:this.life.signal});
        this.prepare();
      }
      load() {
        if (window.gsap) return Promise.resolve(window.gsap);
        if (!window.mpShowcaseGSAP) {
          window.mpShowcaseGSAP = new Promise((resolve,reject) => {
            const script=document.createElement('script');
            script.src='https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
            script.async=true;
            script.onload=() => window.gsap ? resolve(window.gsap) : reject(new Error('GSAP unavailable'));
            script.onerror=() => reject(new Error('GSAP unavailable'));
            document.head.appendChild(script);
          });
        }
        return window.mpShowcaseGSAP;
      }
      async prepare() {
        if (this.dataset.motion!=='true' || this.reduce.matches || this.preparing || this.ctx) return;
        this.preparing=true;
        const life=this.life;
        try {
          const gsap=await this.load();
          if (life.signal.aborted || !this.isConnected || this.reduce.matches) return;
          this.gsap=gsap;
          this.scope=new AbortController();
          this.parts=Array.from(this.querySelectorAll('[data-bottle]')).filter(el=>getComputedStyle(el).display!=='none');
          this.stage=this.querySelector('[data-stage]');
          this.editorial=this.dataset.variant==='editorial';
          this.small=this.compact.matches;
          this.floats=[];
          this.ctx=gsap.context(()=>this.build(gsap),this);
          this.observe();
          this.interactions(gsap);
        } catch(error) {
          this.clear();
        } finally {
          this.preparing=false;
        }
      }
      build(gsap) {
        const reveal=el=>el.querySelector('[data-reveal]');
        const number=(el,name,fallback)=>parseFloat(getComputedStyle(el).getPropertyValue(name)) || fallback;
        const final=el=>({x:0,y:0,z:number(el,'--b-depth',0),rotation:number(el,'--b-rotation',0),rotationY:0,scale:number(el,'--b-scale',1),opacity:1,filter:'blur(0px)'});
        this.tl=gsap.timeline({paused:true,defaults:{ease:'power3.out'},onComplete:()=>this.float(gsap)});
        const main=this.editorial ? this.parts.find(el=>el.dataset.main==='true') : null;
        const normal=this.parts.filter(el=>el!==main);
        const label=this.querySelector('[data-gift]');
        const spot=this.querySelector('[data-bonus-light]');
        const halo=this.querySelector('[data-halo]');
        if (this.editorial) {
          if (main) {
            gsap.set(reveal(main),{opacity:0});
            this.tl.fromTo(reveal(main),{y:this.small?36:65,z:-190,scale:.82,rotation:7,rotationY:-12,opacity:0,filter:'blur(10px)'},{...final(main),duration:this.small?1.25:1.85},0);
          }
          normal.forEach((el,i)=> {
            const front=Number(el.dataset.amplitude)>20;
            const from={x:(el.offsetLeft<this.stage.clientWidth*.5?1:-1)*(this.small?24:90),y:front?60:-35,z:front?80:-240,rotation:(i%2?1:-1)*17,rotationY:(i%2?1:-1)*14,scale:front?1.08:.7,opacity:0,filter:'blur(8px)'};
            gsap.set(reveal(el),{opacity:0});
            this.tl.fromTo(reveal(el),from,{...final(el),duration:this.small?1.15:1.9-i*.08},this.small?.2+i*.12:.4+i*.22);
          });
          this.tl.fromTo(halo,{opacity:.12,scale:.7},{opacity:1,scale:1,duration:this.small?1.8:3},0);
          this.querySelectorAll('[data-editorial-word]').forEach((el,i)=> {
            gsap.set(el,{opacity:0});
            this.tl.fromTo(el,{opacity:0,y:22},{opacity:1,y:0,duration:this.small?.6:.9},.05+i*.12);
          });
          const finder=this.querySelector('[data-finder]');
          gsap.set(finder,{opacity:0});
          this.tl.fromTo(finder,{opacity:0,y:16},{opacity:1,y:0,duration:.65},this.small?.3:.65);
        } else {
          normal.forEach((el,i)=> {
            gsap.set(reveal(el),{opacity:0});
            this.tl.fromTo(reveal(el),{
              x:(this.stage.clientWidth*.5-el.offsetLeft)*.24,
              y:(this.stage.clientHeight*.46-el.offsetTop)*.24,
              z:-90,rotation:(i-2)*2,scale:.84,opacity:0,filter:'blur(4px)'
            },{...final(el),duration:this.small?1.25:1.55},i*.1);
          });
          this.tl.fromTo(halo,{opacity:.25,scale:.9},{opacity:1,scale:1,duration:1.8},0);
        }
        const offerAt=this.small?.65:(this.editorial?1.1:.8);
        if (label) {
          gsap.set(label,{opacity:0});
          this.tl.fromTo(label,{opacity:0,y:12,scale:.95},{opacity:1,y:0,scale:1,duration:.65,ease:'power2.out'},offerAt);
        }
        if (spot) {
          this.tl.fromTo(spot,{opacity:.2,scale:.8},{opacity:1,scale:1.06,duration:.5},offerAt-.15);
          this.tl.to(spot,{opacity:.68,scale:1,duration:.7,ease:'sine.inOut'},offerAt+.35);
        }
        this.parts.forEach((el,i)=> {
          const shadow=el.querySelector('[data-shadow]');
          gsap.set(shadow,{opacity:0});
          this.tl.fromTo(shadow,{opacity:0,scale:.65},{opacity:el===main?.58:.48,scale:1,duration:1.2},el===main?0:i*.1);
        });
        this.tl.to({}, {duration:.2},this.editorial && !this.small?4.6:2.6);
      }
      observe() {
        this.observer=new IntersectionObserver(entries=> {
          this.visible=entries[0].isIntersecting;
          if (this.visible && !this.started) { this.started=true; this.tl.play(0); }
          this.updatePlayback();
        },{threshold:.16});
        this.observer.observe(this.stage);
        document.addEventListener('visibilitychange',()=>this.updatePlayback(),{signal:this.scope.signal});
      }
      updatePlayback() {
        const stopped=this.paused || !this.visible || document.hidden;
        if (this.started) this.tl.paused(stopped);
        this.floats.forEach(t=>t.paused(stopped));
      }
      float(gsap) {
        if (this.floats.length || this.reduce.matches) return;
        this.parts.forEach((el,i)=> {
          this.floats.push(gsap.to(el.querySelector('[data-float]'),{y:(i%2?1:-1)*(this.small?3:6),rotation:(i%2?1:-1)*.5,duration:3.1+i*.27,ease:'sine.inOut',yoyo:true,repeat:-1}));
        });
        this.updatePlayback();
      }
      interactions(gsap) {
        const signal=this.scope.signal;
        this.layers=this.parts.map(el=>({el:el.querySelector('[data-parallax]'),amplitude:Number(el.dataset.amplitude)||10}));
        this.tilts=Array.from(this.querySelectorAll('[data-tilt]'));
        this.callout=this.querySelector('[data-callout-parallax]');
        this.reset=()=> {
          this.layers.forEach(({el})=>gsap.to(el,{x:0,y:0,rotation:0,duration:.9,ease:'power3.out',overwrite:true}));
          if(this.tilts.length) gsap.to(this.tilts,{rotationX:0,rotationY:0,duration:1,overwrite:true});
          if(this.callout) gsap.to(this.callout,{x:0,y:0,rotation:0,duration:.9,ease:'power3.out',overwrite:true});
        };
        this.addEventListener('pointermove',event=> {
          if (!this.desktop.matches || this.paused || !this.visible || this.reduce.matches) return;
          const bounds=this.getBoundingClientRect();
          let x=Math.max(-1,Math.min(1,(event.clientX-bounds.left)/bounds.width*2-1));
          let y=Math.max(-1,Math.min(1,(event.clientY-bounds.top)/bounds.height*2-1));
          const length=Math.max(1,Math.hypot(x,y)); x/=length; y/=length;
          this.layers.forEach(({el,amplitude})=>gsap.to(el,{x:x*amplitude,y:y*amplitude*.72,rotation:x*amplitude/18,duration:.72,ease:'power3.out',overwrite:true}));
          if(this.tilts.length) gsap.to(this.tilts,{rotationX:-y*1.9,rotationY:x*2.7,transformPerspective:1400,duration:1,ease:'power3.out',overwrite:true});
          if(this.callout) {
            const amount=this.editorial?12:9;
            gsap.to(this.callout,{x:-x*amount,y:-y*amount*.55,rotation:-x*.5,duration:.8,ease:'power3.out',overwrite:true});
          }
        },{passive:true,signal});
        this.addEventListener('pointerleave',this.reset,{signal});
        this.desktop.addEventListener('change',this.reset,{signal});
        this.parts.forEach(el=> {
          el.addEventListener('pointerenter',()=> {
            if (!this.editorial || !this.desktop.matches || this.paused) return;
            gsap.to(el.querySelector('[data-hover]'),{scale:1.025,duration:.65,ease:'power3.out',overwrite:true});
          },{signal});
          el.addEventListener('pointerleave',()=>gsap.to(el.querySelector('[data-hover]'),{scale:1,duration:.65,overwrite:true}),{signal});
        });
        this.button=this.querySelector('[data-motion-toggle]');
        if(this.button) {
          this.button.hidden=false;
          this.button.setAttribute('aria-pressed','false');
          this.button.addEventListener('click',()=> {
            this.paused=!this.paused;
            this.button.setAttribute('aria-pressed',String(this.paused));
            this.button.setAttribute('aria-label',this.paused?this.button.dataset.playLabel:this.button.dataset.pauseLabel);
            this.updatePlayback(); this.reset();
          },{signal});
        }
        this.addEventListener('focusin',event=> {
          if(event.target.closest('[data-finder]') && this.tl.progress()<1) this.tl.progress(1);
        },{signal});
      }
      clear() {
        this.scope?.abort();
        this.observer?.disconnect();
        this.floats?.forEach(t=>t.kill());
        this.ctx?.revert();
        this.querySelectorAll('[data-parallax],[data-float],[data-hover],[data-tilt],[data-callout-parallax]').forEach(el=> {
          this.gsap?.killTweensOf(el); el.style.removeProperty('transform');
        });
        if(this.button) this.button.hidden=true;
        this.ctx=null; this.tl=null; this.started=false; this.paused=false;
      }
      disconnectedCallback() { this.life?.abort(); this.clear(); }
    });
  }

  // Reuse the theme's existing predictive search, endpoint and result markup.
  // Guard its clear() method for the no-argument call used when an input is emptied.
  if (!customElements.get('mp-hero-search')) {
    customElements.define('mp-hero-search', class extends HTMLElement {
      connectedCallback() {
        customElements.whenDefined('predictive-search').then(() => {
          if (!this.isConnected) return;
          const search = this.querySelector('predictive-search');
          if (!search || search.dataset.mpReady) return;
          customElements.upgrade(search);
          search.dataset.mpReady = 'true';
          const nativeClear = search.clear.bind(search);
          search.clear = (event) => nativeClear(event || { preventDefault() {} });
          const nativeChange = search.onChange.bind(search);
          search.onChange = (event) => {
            const term = search.getQuery();
            if (!search.searchTerm || !term.startsWith(search.searchTerm)) {
              search.querySelector('[id$="-predictive-search-results-groups-wrapper"]')?.remove();
            }
            nativeChange(event);
          };
          search.querySelector('button[type="button"]').addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            search.close(false);
          }, true);
          const nativeRender = search.renderSearchResults.bind(search);
          search.renderSearchResults = (markup) => {
            nativeRender(markup);
            search.input.removeAttribute('aria-activedescendant');
            // Distinguish result IDs from the separate header search.
            const root = search.querySelector('[data-predictive-search]');
            const idMap = new Map();
            root.querySelectorAll('[id]').forEach((element) => {
              idMap.set(element.id, root.id + '-' + element.id);
            });
            root.querySelectorAll('[id]').forEach((element) => { element.id = idMap.get(element.id); });
            root.querySelectorAll('[aria-labelledby], [aria-describedby], [aria-controls]').forEach((element) => {
              ['aria-labelledby', 'aria-describedby', 'aria-controls'].forEach((attribute) => {
                if (element.hasAttribute(attribute)) {
                  element.setAttribute(attribute, element.getAttribute(attribute).split(' ').map((id) => idMap.get(id) || id).join(' '));
                }
              });
            });
          };
          search.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') { search.close(); search.input.focus(); }
          });
          search.querySelector('form').addEventListener('submit', () => {
            if (!search.input.value.trim()) return;
            this.dispatchEvent(new CustomEvent('mp:hero-search', { bubbles:true }));
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-hero-viewport"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-hero-viewport')) {
    customElements.define('mp-hero-viewport', class extends HTMLElement {
      connectedCallback() {
        this.life=new AbortController();
        this.start=()=> {
          if (!this.isConnected || this.ro) return;
          this.hero=this.closest('.mp-cine');
          if (!this.hero) return;
          this.layout=this.hero.querySelector('.mp-cine__layout');
          this.headingElement=this.hero.querySelector('.mp-cine__title');
          this.visual=this.hero.querySelector('.mp-cine__visual');
          this.finder=this.hero.querySelector('[data-finder]');
          this.usp=this.hero.querySelector('.mp-cine__usp');
          this.header=document.querySelector('.shopify-section-header');
          this.observed=new Set();
          this.schedule=()=> {
            if (this.frame) return;
            this.frame=requestAnimationFrame(()=> { this.frame=0; if(this.isConnected) this.measure(); });
          };
          this.ro=new ResizeObserver(this.schedule);
          [this.headingElement,this.finder,this.usp,this.header,document.body].filter(Boolean).forEach(el=>this.watch(el));
          this.mo=new MutationObserver(this.schedule);
          this.mo.observe(document.body,{childList:true,subtree:true});
          window.addEventListener('resize',this.schedule,{passive:true,signal:this.life.signal});
          window.addEventListener('load',this.schedule,{once:true,signal:this.life.signal});
          document.addEventListener('transitionend',this.schedule,{signal:this.life.signal});
          document.addEventListener('shopify:section:load',this.schedule,{signal:this.life.signal});
          document.addEventListener('shopify:section:unload',this.schedule,{signal:this.life.signal});
          document.fonts?.ready.then(()=> { if(this.isConnected) this.schedule(); });
          this.measure();
        };
        if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',this.start,{once:true,signal:this.life.signal});
        else this.start();
      }
      watch(el) {
        if(this.observed.has(el)) return;
        this.observed.add(el); this.ro.observe(el);
      }
      set(name,value) {
        const next=Math.ceil(value)+'px';
        if(this.hero.style.getPropertyValue(name)!==next) this.hero.style.setProperty(name,next);
      }
      measure() {
        const px=value=>parseFloat(value)||0;
        const margins=el=> { const css=getComputedStyle(el); return px(css.marginTop)+px(css.marginBottom); };
        const outer=el=>el.offsetHeight+margins(el);
        const header=document.querySelector('.shopify-section-header');
        if(header!==this.header) {
          this.header=header;
          if(header) this.watch(header);
        }
        if(header) {
          for(const el of header.parentElement.children) {
            if(el===header) break;
            if(!el.matches('.shopify-section')) continue;
            this.watch(el);
            const css=getComputedStyle(el);
            if(css.display==='none' || css.position==='absolute' || css.position==='fixed') continue;
          }
          const nav=header.querySelector('.header') || header;
          this.watch(nav);
          const transparent=!!header.querySelector('.header-transparent');
          this.set('--mp-header-height',transparent?nav.offsetHeight:0);
        } else this.set('--mp-header-height',0);
        const heroStart=Math.max(0,this.layout.getBoundingClientRect().top+window.scrollY);
        this.set('--mp-topbar-height',heroStart);
        const compact=matchMedia('(max-width:989px)').matches;
        const floor=compact?240:Math.max(300,Math.ceil(this.finder.offsetHeight/.43)+16);
        this.set('--mp-stage-min',floor);
        const style=getComputedStyle(this.layout);
        const minimum=px(style.paddingTop)+px(style.paddingBottom)+outer(this.headingElement)+outer(this.usp)+margins(this.visual)+floor+(compact?outer(this.finder):0);
        this.set('--mp-content-min',minimum);
      }
      disconnectedCallback() {
        this.life?.abort(); this.ro?.disconnect(); this.mo?.disconnect();
        if(this.frame) cancelAnimationFrame(this.frame);
        this.frame=0; this.ro=null; this.mo=null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
